import React from "react";
import { useNavigate } from "react-router-dom";
import { Layout } from "antd";
import AddNewWebsiteIndexEntry from "../deepAnalysis/websiteIndexEntry/addNewWebsite/AddNewWebsiteIndexEntry";


const { Content } = Layout;


export default function AccountSetupPage() {
    const navigate = useNavigate();

    return (
        <Content className="general-layout-content no-padding account-setup">
            <AddNewWebsiteIndexEntry fromOnboarding={true} onFinish={() => navigate("/dashboard")} />
        </Content>
    );
}
